<template>
  <div class="tiaozhengzichanbili-page">
    <div style="display: none;" @click="runAudio">隐藏播放音频按钮</div>
    <div class="header">
      <div class="logo">
        <div class="icon">
          <img src="@/assets/zichanpeizhi/titleicon.png" alt="logo">
        </div>
        <h1>调整资产配置权重</h1>
      </div>
      <div class="total-percentage">
        <i class="el-icon-success"></i>
        总计：{{ totalPercentage }}%
      </div>
    </div>

    <div class="content">
      <div class="main-container">
        <div class="asset-allocation" ref="assetAllocation" @scroll="handleAllocationScroll">
          <p class="sub-title">AI已根据您的风险等级和投资参数，生成了初始配置，您可拖动滑块调整权重，也可点击当前权重输入权重。</p>

          <!-- 股票类资产 -->
          <div class="asset-category stock" v-if="productsBygupiao.length > 0">
            <div class="category-header">
              <div class="header-left">
                <img src="@/assets/zichanpeizhi/icon1.png" alt="logo">
                <span>股票类</span>
              </div>
              <div class="header-meta">
                <span class="meta-item">AI建议：<em>{{ aistockPercentage }}%</em></span>
                <span class="meta-item current-weight">当前权重：<strong>{{ stockPercentage }}%</strong></span>
                <span class="meta-item">产品数量：{{ productsBygupiao.length }}</span>
              </div>
            </div>
            <div class="asset-items">
              <div class="asset-item" v-for="product in productsBygupiao" :key="product.code">
                <div class="asset-item-left">
                  <div class="product-info" @click="handleProductClick(product)">
                    <span class="product-name">{{ product.name }}</span>
                    <span class="product-code">{{ product.code }}</span>
                    <span class="product-type">{{ product.type || '股票型' }}</span>
                  </div>
                  <div class="product-meta">
                    <span>数据区间：{{ product.dataAvailableFrom }} - {{ product.dataAvailableTo }}</span>
                  </div>
                  <div class="product-reason" v-if="product.reason">
                    <span>推荐理由：{{ product.reason }}</span>
                  </div>
                </div>
                <div class="asset-item-right">
                  <div class="asset-item-right-top">
                    <span class="asset-percentage" @click.stop="openWeightNumpad(product)">当前权重
                      <span class="weight-value">{{ product.weight }}%</span>
                    </span>
                    <button class="remove-btn" @click.stop="removeProduct(product, 'stock')">移除</button>
                  </div>
                  <div class="slider-container">
                    <el-slider v-model="product.weight" :min="0" :max="100" :step="0.01"
                               :id="'slider-stock-' + product.code" @change="updateStockAssets"></el-slider>
                    <!-- <span class="asset-percentage">当前权重 {{ product.weight }}%</span> -->
                  </div>
                  <div class="slider-labels">
                    <span>0%</span>
                    <span>50%</span>
                    <span>100%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 债券类资产 -->
          <div class="asset-category bond" v-if="productsByzaiquan.length > 0">
            <div class="category-header">
              <div class="header-left">
                <img src="@/assets/zichanpeizhi/icon2.png" alt="logo">
                <span>债券类</span>
              </div>
              <div class="header-meta">
                <span class="meta-item">AI建议：<em>{{ aibondPercentage }}%</em></span>
                <span class="meta-item current-weight">当前权重：<strong>{{ bondPercentage }}%</strong></span>
                <span class="meta-item">产品数量：{{ productsByzaiquan.length }}</span>
              </div>
            </div>
            <div class="asset-items">
              <div class="asset-item" v-for="product in productsByzaiquan" :key="product.code">
                <div class="asset-item-left">
                  <div class="product-info" @click="handleProductClick(product)">
                    <span class="product-name">{{ product.name }}</span>
                    <span class="product-code">{{ product.code }}</span>
                    <span class="product-type">{{ product.type || '债券型' }}</span>
                  </div>
                  <div class="product-meta">
                    <span>数据区间：{{ product.dataAvailableFrom }} - {{ product.dataAvailableTo }}</span>
                  </div>
                  <div class="product-reason" v-if="product.reason">
                    <span>推荐理由：{{ product.reason }}</span>
                  </div>
                </div>
                <div class="asset-item-right">
                  <div class="asset-item-right-top">
                    <span class="asset-percentage" @click.stop="openWeightNumpad(product)">当前权重
                      <span class="weight-value">{{ product.weight }}%</span>
                    </span>
                    <button class="remove-btn" @click.stop="removeProduct(product, 'bond')">移除</button>
                  </div>
                  <div class="slider-container">
                    <el-slider v-model="product.weight" :min="0" :max="100" :step="0.01"
                               :id="'slider-bond-' + product.code" @change="updateBondAssets"></el-slider>
                    <!-- <span class="asset-percentage">当前权重 {{ product.weight }}%</span> -->
                  </div>
                  <div class="slider-labels">
                    <span>0%</span>
                    <span>50%</span>
                    <span>100%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 基金类资产 -->
          <div class="asset-category fund" v-if="productsByjijin.length > 0">
            <div class="category-header">
              <div class="header-left">
                <img src="@/assets/zichanpeizhi/icon3.png" alt="logo">
                <span>基金类</span>
              </div>
              <div class="header-meta">
                <span class="meta-item">AI建议：<em>{{ aifundPercentage }}%</em></span>
                <span class="meta-item current-weight">当前权重：<strong>{{ fundPercentage }}%</strong></span>
                <span class="meta-item">产品数量：{{ productsByjijin.length }}</span>
              </div>
            </div>
            <div class="asset-items">
              <div class="asset-item" v-for="product in productsByjijin" :key="product.code">
                <div class="asset-item-left">
                  <div class="product-info" @click="handleProductClick(product)">
                    <span class="product-name">{{ product.name }}</span>
                    <span class="product-code">{{ product.code }}</span>
                    <span class="product-type">{{ product.productType }}</span>
                  </div>
                  <div class="product-meta">
                    <span>数据区间：{{ product.dataAvailableFrom }} - {{ product.dataAvailableTo }}</span>
                  </div>
                  <div class="product-reason" v-if="product.reason">
                    <span>推荐理由：{{ product.reason }}</span>
                  </div>
                </div>
                <div class="asset-item-right">
                  <div class="asset-item-right-top">
                    <span class="asset-percentage" @click.stop="openWeightNumpad(product)">当前权重
                      <span class="weight-value">{{ product.weight }}%</span>
                    </span>
                    <button class="remove-btn" @click.stop="removeProduct(product, 'fund')">移除</button>
                  </div>
                  <div class="slider-container">
                    <el-slider v-model="product.weight" :min="0" :max="100" :step="0.01"
                               :id="'slider-fund-' + product.code" @change="updateFundAssets"></el-slider>
                    <!-- <span class="asset-percentage">当前权重 {{ product.weight }}%</span> -->
                  </div>
                  <div class="slider-labels">
                    <span>0%</span>
                    <span>50%</span>
                    <span>100%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="preview-panel">

          <div class="chart-container">
            <h2>配置预览</h2>
            <div class="chart-body">
              <div ref="chartRef" class="pie-chart"></div>
            </div>
          </div>

          <!-- <div class="allocation-suggestion">
            <h3>配置建议</h3>
            <MarkdownRenderer :content="narrativeMarkdown" />
          </div> -->
          <div class="allocation-suggestion" ref="allocationSuggestion" @scroll="handleSuggestionScroll">
            <div class="metrics-section">
              <div class="section-title">
                <span>组合指标</span>
                <span class="sub-label">（基于当前权重测算）</span>
              </div>
              <div class="metrics-grid">
                <div class="metric-card blue">
                  <div class="metric-label">预期年化收益</div>
                  <div class="metric-value">{{ (metrics.expectedAnnualReturn * 100).toFixed(2) }}%</div>
                </div>
                <div class="metric-card green">
                  <div class="metric-label">预期波动率</div>
                  <div class="metric-value">{{ (metrics.expectedVolatility * 100).toFixed(2) }}%</div>
                </div>
                <div class="metric-card blue">
                  <div class="metric-label">夏普比率</div>
                  <div class="metric-value">{{ metrics.expectedSharpeRatio }}</div>
                </div>
                <div class="metric-card red">
                  <div class="metric-label">预期最大回撤</div>
                  <div class="metric-value">{{ (metrics.expectedMaxDrawdown * 100).toFixed(2) }}%</div>
                </div>
              </div>
              <p class="metrics-note">注：仅采用近 1 年短期历史收益简单加权测算，不代表长期均衡收益，仅作演示参考，不预测未来回报。</p>
            </div>

            <div class="summary-section" v-if="narrativeSummary">
              <div class="section-header">
                <i class="el-icon-info blue-icon"></i>
                <span class="section-title-text">配置逻辑摘要</span>
              </div>
              <div class="section-content">
                {{ narrativeSummary }}
              </div>
            </div>

            <div class="compliance-section">
              <div class="section-header">
                <i class="el-icon-check green-icon"></i>
                <span class="section-title-text">合规调整说明</span>
              </div>
              <div class="section-content">
                {{ complianceAdjustment.reason }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <button class="reset-btn common-btn" id="btn-reset-default" @click="resetToDefault">重置为AI默认配置</button>
      <button class="confirm-btn common-btn" id="btn-confirm-allocation" @click="confirmAllocation">确认配置 <i
           class="el-icon-right"></i></button>
    </div>

    <!-- 权重数字键盘弹窗 -->
    <div v-if="showWeightNumpad" class="numpad-mask" @click="closeWeightNumpad"></div>
    <div v-if="showWeightNumpad" class="numpad-popup" @click.stop>
      <div class="numpad-popup-header">
        <span>{{ weightNumpadName }} - 权重（%）</span>
        <button class="numpad-popup-close" @click="closeWeightNumpad">✕</button>
      </div>
      <div class="numpad-popup-display">{{ weightNumpadValue || '0' }}</div>
      <div class="numpad-grid">
        <button class="numpad-btn" v-for="n in [1, 2, 3, 4, 5, 6, 7, 8, 9]" :key="n"
                @click="weightNumpadInput(String(n))">{{ n }}</button>
        <button class="numpad-btn numpad-btn-zero" @click="weightNumpadInput('0')">0</button>
        <button class="numpad-btn" @click="weightNumpadInput('.')">.</button>
        <button class="numpad-btn numpad-btn-del" @click="weightNumpadDelete">删除</button>
      </div>
      <button class="numpad-confirm" @click="confirmWeightNumpad">确认</button>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import apiOpen from '@/api/open'
// import MarkdownRenderer from '@/components/MarkdownRenderer.vue'

export default {
  name: 'Tiaozhengzichanbili',
  components: {
    // MarkdownRenderer
  },
  data () {
    return {
      stockPercentage: 0,
      bondPercentage: 0,
      fundPercentage: 0,
      aistockPercentage: 0,
      aibondPercentage: 0,
      aifundPercentage: 0,
      totalPercentage: 0,
      stockAssets: {
        ningde: 50,
        pingan: 50
      },
      bondAssets: {
        guozhai: 100
      },
      fundAssets: {
        hushen: 100
      },
      chart: null,
      productsByType: [],
      productsBygupiao: [],//股票类资产
      productsByzaiquan: [],//债券类资产
      productsByjijin: [],//基金类资产(混合型)
      narrativeMarkdown: '',//配置建议
      metrics: { //组合指标
        expectedAnnualReturn: 0,//预期年化收益
        expectedMaxDrawdown: 0,//预期最大回撤
        expectedSharpeRatio: 0,//夏普比率
        expectedVolatility: 0,//预期波动率
      },
      narrativeSummary: '',//配置逻辑摘要
      complianceAdjustment: {//合规调整说明
        reason: '',//合规调整理由
      },
      weightsSyncTimer: null,
      allocationScrollTimer: null,
      suggestionScrollTimer: null,
      metricsDebounceTimer: null,
      evaluationDate: '',
      remoteApplyTime: 0,
      lastSentAllocationRatio: -1,
      showWeightNumpad: false,
      weightNumpadValue: '',
      weightNumpadTarget: null,
      weightNumpadName: '',
      lastSentSuggestionRatio: -1
    }
  },
  created () {
    this.runAudio()
    const recommendResult = JSON.parse(localStorage.getItem('recommendResult'))
    const NewrecommendResult = JSON.parse(localStorage.getItem('NewrecommendResult'))
    // 记录 AI 默认大类权重
    this.saveAiDefaultPercentages(recommendResult)

    if (NewrecommendResult) {//如果有新配置
      NewrecommendResult.products.forEach(item => {
        if (item.typename === '股票类') {//股票类资产
          this.$set(item, 'weight', Number((item.weight || 0).toFixed(2)))
          this.productsBygupiao.push(item)
        } else if (item.typename === '债券类') {//债券类资产
          this.$set(item, 'weight', Number((item.weight || 0).toFixed(2)))
          this.productsByzaiquan.push(item)
        } else if (item.typename === '基金类') {//基金类资产(混合型)
          this.$set(item, 'weight', Number((item.weight || 0).toFixed(2)))
          this.productsByjijin.push(item)
        }
      })
    }
    // if (recommendResult) {
    else {//如果没有新配置，使用默认配置
      // 股票类资产
      if (recommendResult.stocks && recommendResult.stocks.length > 0) {
        recommendResult.stocks.forEach(item => {
          this.$set(item, 'weight', Number((item.weight * 100 || 0).toFixed(2)))
          this.$set(item, 'typename', '股票类')
        })
        this.productsBygupiao = recommendResult.stocks
      }
      // 债券类资产
      if (recommendResult.bonds && recommendResult.bonds.length > 0) {
        recommendResult.bonds.forEach(item => {
          this.$set(item, 'weight', Number((item.weight * 100 || 0).toFixed(2)))
          this.$set(item, 'typename', '债券类')
        })
        this.productsByzaiquan = recommendResult.bonds
      }
      // 基金类资产(混合型)
      if (recommendResult.funds && recommendResult.funds.length > 0) {
        recommendResult.funds.forEach(item => {
          this.$set(item, 'weight', Number((item.weight * 100 || 0).toFixed(2)))
          this.$set(item, 'typename', '基金类')
        })
        this.productsByjijin = recommendResult.funds
      }
    }
    // 配置建议
    this.narrativeMarkdown = recommendResult.narrativeMarkdown
    // 组合指标
    this.metrics = recommendResult.metrics
    // 评估日期
    this.evaluationDate = recommendResult.evaluationDate || ''
    // 配置逻辑摘要
    this.narrativeSummary = recommendResult.narrativeSummary
    // 合规调整说明
    this.complianceAdjustment = recommendResult.complianceAdjustment
    this.calculatePercentages()
  },
  mounted () {
    this.initChart()
    this.$nextTick(() => {
      this.restoreAllocationScroll()
      this.restoreSuggestionScroll()
    })
    window.addEventListener('storage', this.handleStorageChange)
  },
  beforeDestroy () {
    window.removeEventListener('storage', this.handleStorageChange)
    if (this.weightsSyncTimer) {
      clearTimeout(this.weightsSyncTimer)
      this.weightsSyncTimer = null
    }
    if (this.allocationScrollTimer) {
      clearTimeout(this.allocationScrollTimer)
      this.allocationScrollTimer = null
    }
    if (this.suggestionScrollTimer) {
      clearTimeout(this.suggestionScrollTimer)
      this.suggestionScrollTimer = null
    }
    if (this.metricsDebounceTimer) {
      clearTimeout(this.metricsDebounceTimer)
      this.metricsDebounceTimer = null
    }
  },
  watch: {
    stockPercentage () {
      this.updateChart()
    },
    bondPercentage () {
      this.updateChart()
    },
    fundPercentage () {
      this.updateChart()
    }
  },

  methods: {
    // 播放音频
    runAudio () {
      this.playOnceAudio('/生成初始配置完成，您可拖动滑块自行配置资产.mp3')
    },
    initChart () {
      this.chart = echarts.init(this.$refs.chartRef)
      this.updateChart()
      window.addEventListener('resize', () => {
        this.chart.resize()
      })
    },
    updateChart () {
      if (!this.chart) return

      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}%'
        },
        legend: {
          orient: 'vertical',
          right: '5%',
          top: 'center',
          data: ['股票类', '债券类', '基金类'],
          formatter: (name) => {
            const map = { '股票类': this.stockPercentage, '债券类': this.bondPercentage, '基金类': this.fundPercentage }
            return `${name}  ${map[name]}%`
          }
        },
        series: [
          {
            name: '资产配置',
            type: 'pie',
            center: ['25%', '50%'],
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: true,
              position: 'center',
              formatter: `${this.totalPercentage}%`
            },
            labelLine: {
              show: false
            },
            data: [
              {
                value: this.stockPercentage,
                name: '股票类',
                itemStyle: {
                  color: '#3b82f6'
                }
              },
              {
                value: this.bondPercentage,
                name: '债券类',
                itemStyle: {
                  color: '#10b981'
                }
              },
              {
                value: this.fundPercentage,
                name: '基金类',
                itemStyle: {
                  color: '#f59e0b'
                }
              }
            ]
          }
        ]
      }

      this.chart.setOption(option)
    },
    updateAllocation () {
    },
    // 记录 AI 推荐的大类默认权重（百分比）
    saveAiDefaultPercentages (recommendResult) {
      if (!recommendResult) return
      // 优先从 allocation 字段取（API 返回的合规后大类权重）
      if (recommendResult.allocation && recommendResult.allocation.length > 0) {
        const findWeight = (name) => {
          const item = recommendResult.allocation.find(a => a.assetClass === name)
          return item ? Number((item.weight * 100).toFixed(2)) : 0
        }
        this.aistockPercentage = findWeight('股票')
        this.aibondPercentage = findWeight('债券')
        this.aifundPercentage = findWeight('基金')
      } else {
        // fallback：从 stocks/bonds/funds 数组累加
        const sumWeight = (arr) => arr ? Number((arr.reduce((s, p) => s + (p.weight || 0), 0) * 100).toFixed(2)) : 0
        this.aistockPercentage = sumWeight(recommendResult.stocks)
        this.aibondPercentage = sumWeight(recommendResult.bonds)
        this.aifundPercentage = sumWeight(recommendResult.funds)
      }
    },
    calculatePercentages () {
      this.stockPercentage = Number(this.productsBygupiao.reduce((sum, item) => sum + (item.weight || 0), 0).toFixed(2))
      this.bondPercentage = Number(this.productsByzaiquan.reduce((sum, item) => sum + (item.weight || 0), 0).toFixed(2))
      this.fundPercentage = Number(this.productsByjijin.reduce((sum, item) => sum + (item.weight || 0), 0).toFixed(2))
      this.totalPercentage = Number((this.stockPercentage + this.bondPercentage + this.fundPercentage).toFixed(2))
    },
    updateStockAssets () {
      this.calculatePercentages()
      this.syncWeightsToStorage()
      this.updateChart()
      this.scheduleRecalculateMetrics()
    },
    updateBondAssets () {
      this.calculatePercentages()
      this.syncWeightsToStorage()
      this.updateChart()
      this.scheduleRecalculateMetrics()
    },
    updateFundAssets () {
      this.calculatePercentages()
      this.syncWeightsToStorage()
      this.updateChart()
      this.scheduleRecalculateMetrics()
    },
    removeProduct (product, category) {
      this.$confirm(`确认移除标"${product.name}"？移除后，该权重将按剩余标的自动重算。`, '提示', {
        confirmButtonText: '确认移除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const categoryKey = category === 'stock' ? 'productsBygupiao' : (category === 'bond' ? 'productsByzaiquan' : 'productsByjijin')
        const list = this[categoryKey]
        const idx = list.findIndex(p => p.code === product.code)
        if (idx === -1) return
        list.splice(idx, 1)
        // 收集所有剩余标的，均分 100%，最后一项兜底保证精确到 100.00
        const allRemaining = [
          ...this.productsBygupiao,
          ...this.productsByzaiquan,
          ...this.productsByjijin
        ]
        if (allRemaining.length > 0) {
          const equal = Number((100 / allRemaining.length).toFixed(2))
          allRemaining.forEach((p, i) => {
            p.weight = i === allRemaining.length - 1
              ? Number((100 - equal * (allRemaining.length - 1)).toFixed(2))
              : equal
          })
        }
        this.calculatePercentages()
        this.syncWeightsToStorage()
        this.updateChart()
        this.scheduleRecalculateMetrics()
        // 同步更新 localStorage 中的 NewrecommendResult
        const allProducts = this.productsBygupiao.concat(this.productsByzaiquan, this.productsByjijin)
        localStorage.setItem('NewrecommendResult', JSON.stringify({ products: allProducts }))
        this.$message.success('已移除')
      }).catch(() => { /* 用户取消 */ })
    },
    // 防抖调用 RecalculateMetrics，滑块拖动频繁时只发最后一次
    scheduleRecalculateMetrics () {
      if (this.metricsDebounceTimer) clearTimeout(this.metricsDebounceTimer)
      this.metricsDebounceTimer = setTimeout(() => {
        this.recalculateMetrics()
      }, 300)
    },
    recalculateMetrics () {
      const products = [
        ...this.productsBygupiao.map(p => ({ code: p.code, weight: p.weight })),
        ...this.productsByzaiquan.map(p => ({ code: p.code, weight: p.weight })),
        ...this.productsByjijin.map(p => ({ code: p.code, weight: p.weight }))
      ]
      const evaluationDate = this.evaluationDate || new Date().toISOString().slice(0, 10)
      apiOpen.RecalculateMetrics({
        products,
        evaluationDate
      }).then(res => {
        // console.log('RecalculateMetrics 返回：', res)
        const data = res?.data || res
        // 接口返回的 data 本身即是 metrics 对象（含 expectedAnnualReturn 等字段）
        if (data && data.expectedAnnualReturn !== undefined) {
          this.metrics = data
        } else if (data && data.metrics) {
          this.metrics = data.metrics
        }
        if (data && data.narrativeSummary !== undefined) {
          this.narrativeSummary = data.narrativeSummary
        }
        if (data && data.complianceAdjustment !== undefined) {
          this.complianceAdjustment = data.complianceAdjustment
        }
        // 同步组合指标到副屏
        this.syncMetricsToStorage()
      }).catch(err => {
        console.error('RecalculateMetrics 失败：', err)
      })
    },
    syncMetricsToStorage () {
      localStorage.setItem('adjustMetrics', JSON.stringify({
        metrics: this.metrics,
        narrativeSummary: this.narrativeSummary,
        complianceAdjustment: this.complianceAdjustment
      }))
    },
    // ---- 权重数字键盘弹窗 ----
    openWeightNumpad (product) {
      this.weightNumpadTarget = product
      this.weightNumpadName = product.name || product.code || ''
      this.weightNumpadValue = String(product.weight)
      this.showWeightNumpad = true
    },
    closeWeightNumpad () {
      this.showWeightNumpad = false
      this.weightNumpadTarget = null
    },
    weightNumpadInput (char) {
      if (char === '.' && this.weightNumpadValue.includes('.')) return
      if (this.weightNumpadValue.length >= 8) return
      // 已有小数点，最多两位小数
      const dotIndex = this.weightNumpadValue.indexOf('.')
      if (dotIndex !== -1 && char !== '.' && this.weightNumpadValue.length - dotIndex > 2) return
      this.weightNumpadValue += char
    },
    weightNumpadDelete () {
      this.weightNumpadValue = this.weightNumpadValue.slice(0, -1)
    },
    confirmWeightNumpad () {
      const val = parseFloat(this.weightNumpadValue)
      if (isNaN(val) || val < 0) {
        this.$message.warning('请输入有效的数值')
        return
      }
      if (val > 100) {
        this.$message.warning('权重不能超过 100%')
        return
      }
      const target = this.weightNumpadTarget
      if (target) {
        this.$set(target, 'weight', val)
        // 根据产品所属列表触发对应的计算
        if (this.productsBygupiao.includes(target)) {
          this.updateStockAssets()
        } else if (this.productsByzaiquan.includes(target)) {
          this.updateBondAssets()
        } else if (this.productsByjijin.includes(target)) {
          this.updateFundAssets()
        }
      }
      this.showWeightNumpad = false
      this.weightNumpadTarget = null
    },
    syncWeightsToStorage () {
      if (this.weightsSyncTimer) clearTimeout(this.weightsSyncTimer)
      this.weightsSyncTimer = setTimeout(() => {
        const allProducts = [
          ...this.productsBygupiao.map(p => ({ code: p.code, weight: p.weight, typename: '股票类' })),
          ...this.productsByzaiquan.map(p => ({ code: p.code, weight: p.weight, typename: '债券类' })),
          ...this.productsByjijin.map(p => ({ code: p.code, weight: p.weight, typename: '基金类' }))
        ]
        localStorage.setItem('adjustWeights', JSON.stringify(allProducts))
        this.weightsSyncTimer = null
      }, 100)
    },
    handleStorageChange (event) {
      if (event.key === 'adjustWeights' && event.newValue) {
        this.applyWeightsFromStorage(JSON.parse(event.newValue))
      } else if (event.key === 'adjustMetrics' && event.newValue) {
        try {
          const data = JSON.parse(event.newValue)
          if (data && data.metrics) {
            this.metrics = data.metrics
          }
          if (data && data.narrativeSummary !== undefined) {
            this.narrativeSummary = data.narrativeSummary
          }
          if (data && data.complianceAdjustment !== undefined) {
            this.complianceAdjustment = data.complianceAdjustment
          }
        } catch (e) { /* ignore */ }
      } else if (event.key === 'allocationScrollPercent' && event.newValue) {
        this.remoteApplyTime = Date.now()
        const el = this.$refs.assetAllocation
        if (!el) return
        const percent = parseFloat(event.newValue)
        if (el.scrollHeight > el.clientHeight) {
          el.scrollTop = percent * (el.scrollHeight - el.clientHeight)
        }
      } else if (event.key === 'suggestionScrollPercent' && event.newValue) {
        this.remoteApplyTime = Date.now()
        const el = this.$refs.allocationSuggestion
        if (!el) return
        const percent = parseFloat(event.newValue)
        if (el.scrollHeight > el.clientHeight) {
          el.scrollTop = percent * (el.scrollHeight - el.clientHeight)
        }
      }
    },
    applyWeightsFromStorage (weights) {
      if (!weights || !Array.isArray(weights)) return
      const lookup = {}
      weights.forEach(w => { lookup[w.code + '|' + w.typename] = w.weight })
      const apply = (arr) => {
        arr.forEach(item => {
          const key = item.code + '|' + item.typename
          if (lookup[key] !== undefined) {
            item.weight = lookup[key]
          }
        })
      }
      apply(this.productsBygupiao)
      apply(this.productsByzaiquan)
      apply(this.productsByjijin)
      this.calculatePercentages()
      this.updateChart()
    },
    handleAllocationScroll () {
      const el = this.$refs.assetAllocation
      if (!el) return
      // 时间戳防抖：刚应用远程滚动 200ms 内不写入，阻断反馈循环
      if (Date.now() - this.remoteApplyTime < 200) return
      const percent = el.scrollHeight > el.clientHeight
        ? el.scrollTop / (el.scrollHeight - el.clientHeight)
        : 0
      // 跳过重复比例，避免无意义写入
      if (Math.abs(percent - this.lastSentAllocationRatio) < 0.002) return
      this.lastSentAllocationRatio = percent
      if (this.allocationScrollTimer) clearTimeout(this.allocationScrollTimer)
      this.allocationScrollTimer = setTimeout(() => {
        localStorage.setItem('allocationScrollPercent', String(percent))
        this.allocationScrollTimer = null
      }, 100)
    },
    restoreAllocationScroll () {
      this.remoteApplyTime = Date.now()
      const saved = localStorage.getItem('allocationScrollPercent')
      if (saved === null) return
      const el = this.$refs.assetAllocation
      if (!el) return
      const percent = parseFloat(saved)
      this.$nextTick(() => {
        if (el.scrollHeight > el.clientHeight) {
          el.scrollTop = percent * (el.scrollHeight - el.clientHeight)
        }
      })
    },
    handleSuggestionScroll () {
      const el = this.$refs.allocationSuggestion
      if (!el) return
      // 时间戳防抖：刚应用远程滚动 200ms 内不写入，阻断反馈循环
      if (Date.now() - this.remoteApplyTime < 200) return
      const percent = el.scrollHeight > el.clientHeight
        ? el.scrollTop / (el.scrollHeight - el.clientHeight)
        : 0
      // 跳过重复比例，避免无意义写入
      if (Math.abs(percent - this.lastSentSuggestionRatio) < 0.002) return
      this.lastSentSuggestionRatio = percent
      if (this.suggestionScrollTimer) clearTimeout(this.suggestionScrollTimer)
      this.suggestionScrollTimer = setTimeout(() => {
        localStorage.setItem('suggestionScrollPercent', String(percent))
        this.suggestionScrollTimer = null
      }, 100)
    },
    restoreSuggestionScroll () {
      this.remoteApplyTime = Date.now()
      const saved = localStorage.getItem('suggestionScrollPercent')
      if (saved === null) return
      const el = this.$refs.allocationSuggestion
      if (!el) return
      const percent = parseFloat(saved)
      this.$nextTick(() => {
        if (el.scrollHeight > el.clientHeight) {
          el.scrollTop = percent * (el.scrollHeight - el.clientHeight)
        }
      })
    },
    // 点击产品信息 → 跳转交易数据折线图页面
    handleProductClick (product) {
      if (!product || !product.code) return
      // 写入 localStorage，供副屏无参加载时兜底
      localStorage.setItem('jiaoyishuju_params', JSON.stringify({
        code: product.code,
        name: product.name || product.code,
        start: product.dataAvailableFrom || '',
        end: product.dataAvailableTo || ''
      }))
      this.$router.push({
        name: 'Jiaoyishuju',
        query: {
          code: product.code,
          name: product.name || product.code,
          start: product.dataAvailableFrom || '',
          end: product.dataAvailableTo || ''
        }
      })
    },
    // 重置为AI默认配置
    resetToDefault () {
      const recommendResult = JSON.parse(localStorage.getItem('recommendResult'))
      if (recommendResult) {
        this.productsBygupiao = []
        this.productsByzaiquan = []
        this.productsByjijin = []
        // 股票类资产
        if (recommendResult.stocks && recommendResult.stocks.length > 0) {
          recommendResult.stocks.forEach(item => {
            this.$set(item, 'weight', Number((item.weight * 100 || 0).toFixed(2)))
            this.$set(item, 'typename', '股票类')
          })
          this.productsBygupiao = recommendResult.stocks
        }
        // 债券类资产
        if (recommendResult.bonds && recommendResult.bonds.length > 0) {
          recommendResult.bonds.forEach(item => {
            this.$set(item, 'weight', Number((item.weight * 100 || 0).toFixed(2)))
            this.$set(item, 'typename', '债券类')
          })
          this.productsByzaiquan = recommendResult.bonds
        }
        // 基金类资产(混合型)
        if (recommendResult.funds && recommendResult.funds.length > 0) {
          recommendResult.funds.forEach(item => {
            this.$set(item, 'weight', Number((item.weight * 100 || 0).toFixed(2)))
            this.$set(item, 'typename', '基金类')
          })
          this.productsByjijin = recommendResult.funds
        }

        this.narrativeMarkdown = recommendResult.narrativeMarkdown
        this.saveAiDefaultPercentages(recommendResult)
        this.calculatePercentages()
        this.updateChart()
        this.syncWeightsToStorage()
        this.recalculateMetrics()
        localStorage.removeItem('NewrecommendResult')
        this.$message.success('已重置为AI默认配置')
      }
    },
    confirmAllocation () {
      if (this.totalPercentage !== 100) {
        this.$message.error('资产配置总和必须为100%')
        return
      }
      // 收集所有剩余资产的数据区间，取交集
      const allProducts = [...this.productsBygupiao, ...this.productsByzaiquan, ...this.productsByjijin]
      if (allProducts.length > 0) {
        const validProducts = allProducts.filter(p => p.dataAvailableFrom && p.dataAvailableTo)
        if (validProducts.length > 0) {
          const maxStart = validProducts.reduce((max, p) => p.dataAvailableFrom > max ? p.dataAvailableFrom : max, validProducts[0].dataAvailableFrom)
          const minEnd = validProducts.reduce((min, p) => p.dataAvailableTo < min ? p.dataAvailableTo : min, validProducts[0].dataAvailableTo)
          localStorage.setItem('assetDateIntersection', JSON.stringify({ start: maxStart, end: minEnd }))
        }
      }
      // 组合新提交的 股票债券基金集合
      let products = this.productsBygupiao.concat(this.productsByzaiquan, this.productsByjijin)
      // 存储新提交的配置
      localStorage.setItem('NewrecommendResult', JSON.stringify({
        products: products
      }))
      this.$router.push({ name: 'Lishihuice' })
    }
  }
}
</script>

<style scoped lang="less">
.tiaozhengzichanbili-page {
  min-height: 100vh;
  // background: linear-gradient(135deg, #f0f4ff 0%, #e8f0ff 50%, #f5f0ff 100%);
  background: url('../../assets/bg-hp.png') no-repeat;
  background-size: 100% 100%;
  padding: 30px 80px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo i {
  font-size: 32px;
  color: #3b82f6;
}

.logo h1 {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.icon {
  width: 36px;
  height: 36px;
  background: #486dff;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 24px;
    height: 24px;
    object-fit: cover;
  }
}

.slider-labels {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 12px;
  color: #94a3b8;
}

.total-percentage {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #d1fae5;
  color: #065f46;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 500;
}

.total-percentage i {
  color: #10b981;
}

.content {
  margin-bottom: 40px;
}

.main-container {
  display: flex;
  gap: 20px;
}

.asset-allocation {
  max-height: 750px;
  overflow-x: auto;
  flex: 2;
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);

  .title2 {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    img {
      width: 26px;
      height: 26px;
    }

    h2 {
      font-size: 24px;
      font-weight: 600;
      color: #1e293b;
      margin-left: 12px;
    }
  }
}

.sub-title {
  color: #64748b;
  margin: 0 0 12px 0;
  font-size: 16px;
}

.asset-category {
  background: #f8fafc;
  border-radius: 12px;
  padding: 12px 24px;
  margin-bottom: 12px;
  border: 1px solid #e2e8f0;
}

.asset-category.stock {
  border-left: 4px solid #3b82f6;
}

.asset-category.bond {
  border-left: 4px solid #10b981;
}

.asset-category.fund {
  border-left: 4px solid #f59e0b;
}

.category-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 12px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.header-left img {
  width: 22px;
  height: 22px;
  object-fit: contain;
}

.header-left span {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
}

.header-meta {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.meta-item {
  font-size: 13px;
  color: #64748b;
  white-space: nowrap;
}

.meta-item em {
  font-style: normal;
  color: #8b5cf6;
  font-weight: 500;
}

.meta-item.current-weight {
  color: #1e293b;
}

.meta-item.current-weight strong {
  color: #3b82f6;
  font-weight: 600;
}

.category-header i {
  font-size: 20px;
  margin-right: 12px;
}

.asset-items {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.asset-item {
  display: flex;
  flex-direction: row;
  gap: 24px;
  padding: 16px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  align-items: flex-start;
}

.asset-item-left {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.product-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.asset-item-right {
  width: 270px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.asset-item-right-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.remove-btn {
  padding: 2px 10px;
  font-size: 12px;
  color: #ef4444;
  background: transparent;
  border: 1px solid #fecaca;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
}

.remove-btn:hover {
  color: #fff;
  background: #ef4444;
  border-color: #ef4444;
}

.slider-container {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  cursor: pointer;
  padding: 4px 8px;
  margin: -4px -8px;
  transition: background 0.2s;
}

.product-info:hover {
  background: rgba(37, 99, 235, 0.04);
  border-radius: 6px;
}

.product-name {
  font-size: 14px;
  font-weight: 600;
  color: #2563eb;
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-color: rgba(37, 99, 235, 0.35);
  transition: text-decoration-color 0.2s;
  cursor: pointer;
}

.product-info:hover .product-name {
  text-decoration-color: #2563eb;
}

.product-code {
  font-size: 12px;
  color: #64748b;
}

.product-type {
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 4px;
  background: #f1f5f9;
  color: #64748b;
}

.product-meta {
  font-size: 12px;
  color: #94a3b8;
}

.product-reason {
  font-size: 12px;
  color: #64748b;
  padding: 8px 12px;
  background: #f8fafc;
  border-radius: 6px;
  margin-top: 4px;
}

.slider-container {
  display: flex;
  align-items: center;
  gap: 16px;
}

.slider-container .el-slider {
  flex: 1;
}

.asset-percentage {
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  min-width: 100px;
  text-align: right;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  transition: color 0.2s;
}

.weight-value {
  display: inline-block;
  padding: 2px 8px;
  font-weight: 600;
  color: #2563eb;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  background: #f8fafc;
  transition: all 0.2s;
}

.asset-percentage:hover .weight-value {
  border-color: #3b82f6;
  background: #eff6ff;
}

.preview-panel {
  flex: 1;
  max-height: 750px;
  overflow-x: hidden;
  overflow-y: auto;
}

.preview-panel h2 {
  font-size: 24px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 24px 0;
}

.chart-container {
  background: #fff;
  border-radius: 12px;
  padding: 24px 32px;
  margin-bottom: 12px;
}

.chart-container h2 {
  font-size: 24px;
  font-weight: 600;
  color: #155dfc;
  margin: 0 0 24px 0;
}

.chart-body {
  display: flex;
  justify-content: flex-start;
}

.pie-chart {
  width: 420px;
  height: 240px;
}

.allocation-suggestion {
  height: 350px;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #e2e8f0;
}

.metrics-section {
  margin-bottom: 16px;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.sub-label {
  font-size: 12px;
  font-weight: 400;
  color: #64748b;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.metrics-note {
  margin: 10px 0 0;
  font-size: 12px;
  color: #94a3b8;
  line-height: 1.5;
}

.metric-card {
  padding: 12px;
  border-radius: 8px;
}

.metric-card.blue {
  background: #eff6ff;
}

.metric-card.green {
  background: #ecfdf5;
}

.metric-card.red {
  background: #fef2f2;
}

.metric-label {
  font-size: 12px;
  color: #64748b;
  margin-bottom: 4px;
}

.metric-value {
  font-size: 18px;
  font-weight: 600;
}

.metric-card.blue .metric-value {
  color: #3b82f6;
}

.metric-card.green .metric-value {
  color: #10b981;
}

.metric-card.red .metric-value {
  color: #ef4444;
}

.summary-section,
.compliance-section {
  margin-bottom: 12px;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.section-title-text {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

.blue-icon {
  color: #3b82f6;
}

.green-icon {
  color: #10b981;
}

.section-content {
  font-size: 13px;
  color: #475569;
  line-height: 1.6;
  padding: 12px;
  border-radius: 8px;
  background: #f8fafc;
}

.footer {
  display: flex;
  justify-content: center;
  gap: 24px;
}

.reset-btn {
  background: white;
  width: 240px;
  font-size: 18px;
  color: #64748b;
}

.reset-btn:hover {
  border-color: #3b82f6;
  color: #3b82f6;
}

.confirm-btn {
  width: 240px;
  font-size: 18px;
}

.confirm-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.4);
}

/* 横屏小尺寸适配 */
@media screen and (orientation: landscape) and (max-width: 1366px) {
  .tiaozhengzichanbili-page {
    padding: 20px 40px;
  }

  .header {
    margin-bottom: 10px;
  }

  .logo h1 {
    font-size: 28px;
  }

  .logo i {
    font-size: 28px;
  }

  .total-percentage {
    font-size: 14px;
    padding: 6px 12px;
  }

  .main-container {
    grid-template-columns: 1fr;
    gap: 30px;
    // padding: 30px;
  }

  .asset-allocation {
    max-height: 640px;
    overflow-x: auto;
  }

  .asset-allocation h2,
  .preview-panel h2 {
    font-size: 20px;
  }

  .sub-title {
    font-size: 14px;
    margin-bottom: 12px;
  }

  .asset-category {
    padding: 10px 20px;
    margin-bottom: 5px;
  }

  .category-header {
    margin-bottom: 5px;
  }

  .category-header span {
    font-size: 16px;
  }

  .chart-container {
    padding: 24px;
  }

  .pie-chart {
    width: 100%;
    height: 180px;
  }

  .reset-btn,
  .confirm-btn {
    padding: 12px 36px;
    font-size: 14px;
  }

  .content {
    margin-bottom: 10px;
  }
}

/* 竖屏适配 */
@media screen and (orientation: portrait) {
  .tiaozhengzichanbili-page {
    padding: 20px 16px;
    min-height: 100vh;
    // background: linear-gradient(180deg, #f0f4ff 0%, #faf5ff 50%, #f0f9ff 100%);
    background: url('../../assets/bg-sp.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    // gap: 16px;
  }

  .header {
    display: flex;
    justify-content: center;
    // flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-bottom: 0;
    // padding-top: 10px;
  }

  .logo {
    // flex-direction: column;
    gap: 8px;
  }

  .logo h1 {
    font-size: 18px;
    font-weight: 700;
    // color: #1e293b;
    letter-spacing: 0.5px;
    // background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%);
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    // background-clip: text;
    margin: 0;
  }

  .logo i {
    font-size: 20px;
    // color: #6366f1;
  }

  .total-percentage {
    padding: 8px 16px;
    // background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    // color: #4338ca;
    // border: 1px solid rgba(99, 102, 241, 0.1);
  }

  .main-container {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .asset-allocation {
    max-height: 500px;
    // display: none;
    padding: 20px;
    border-radius: 16px;
    // box-shadow: 0 8px 24px rgba(99, 102, 241, 0.08);
    // background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    // border: 1px solid rgba(99, 102, 241, 0.08);
  }

  .preview-panel {
    // padding: 20px;
    border-radius: 16px;
    // box-shadow: 0 8px 24px rgba(99, 102, 241, 0.08);
    // background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    // border: 1px solid rgba(99, 102, 241, 0.08);
  }

  .asset-allocation h2,
  .preview-panel h2 {
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 16px;
  }

  .sub-title {
    font-size: 13px;
    color: #64748b;
    margin-bottom: 16px;
  }

  .asset-category {
    padding: 14px;
    margin-bottom: 12px;
    // background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    // border-radius: 10px;
    // border: 1px solid rgba(99, 102, 241, 0.08);
  }

  .category-header {
    margin-bottom: 10px;
  }

  .header-left span {
    font-size: 14px;
    font-weight: 600;
    color: #334155;
  }

  .meta-item {
    font-size: 12px;
  }

  .meta-item em {
    font-size: 12px;
  }

  .asset-item {
    flex-direction: column;
    gap: 12px;
    padding: 10px;
    background: white;
    border-radius: 8px;
    border: 1px solid rgba(99, 102, 241, 0.06);
  }

  .asset-item-right {
    width: 100%;
  }

  .product-info {
    gap: 8px;
  }

  .product-name {
    font-size: 12px;
    font-weight: 600;
    color: #2563eb;
    text-decoration: underline;
    text-underline-offset: 2px;
    text-decoration-color: rgba(37, 99, 235, 0.35);
    cursor: pointer;
  }

  .product-code {
    font-size: 11px;
  }

  .product-type {
    font-size: 10px;
    padding: 2px 6px;
    border-radius: 4px;
  }

  .product-meta {
    font-size: 11px;
  }

  .product-reason {
    font-size: 11px;
    padding: 6px 10px;
  }

  .chart-container {
    padding: 16px;
    //background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 12px;
    border: 1px solid rgba(99, 102, 241, 0.08);
    margin-bottom: 4px;
  }

  .chart-container h2 {
    margin: 0;
  }

  .chart-body {
    justify-content: center;
  }

  .pie-chart {
    width: 280px;
    height: 200px;
  }

  .allocation-suggestion {
    height: 400px;
    padding: 14px;
    //background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
    border-radius: 10px;
    border: 1px solid rgba(251, 191, 36, 0.2);
  }

  .allocation-suggestion h3 {
    font-size: 14px;
    font-weight: 600;
    color: #b45309;
    margin-bottom: 12px;
  }

  .allocation-suggestion li {
    font-size: 12px;
    color: #92400e;
    margin-bottom: 6px;
  }

  .footer {
    display: none;
    flex-direction: column;
    gap: 12px;
    margin-top: 0;
    padding-top: 0;
  }

  .reset-btn {
    width: 100%;
    padding: 14px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 12px;
    background: white;
    border: 2px solid #e2e8f0;
    color: #64748b;
    transition: all 0.2s ease;
  }

  .reset-btn:hover {
    border-color: #6366f1;
    color: #6366f1;
  }

  .confirm-btn {
    width: 100%;
    padding: 14px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 12px;
    background: linear-gradient(135deg, #6366f1 0%, #4f46e5 50%, #7c3aed 100%);
    border: none;
    color: white;
    box-shadow: 0 4px 14px rgba(99, 102, 241, 0.35);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.5px;
    position: relative;
    overflow: hidden;
  }

  .confirm-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s ease;
  }

  .confirm-btn:hover::before {
    left: 100%;
  }

  .confirm-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(99, 102, 241, 0.45);
  }

  .content {
    margin-bottom: 0;
  }
}

/* 小屏幕适配 */
@media (max-width: 768px) {
  .tiaozhengzichanbili-page {
    padding: 16px 16px;
  }

  .header {
    // margin-bottom: 20px;
  }

  .logo h1 {
    font-size: 20px;
  }

  .logo i {
    font-size: 20px;
  }

  .main-container {
    padding: 20px;
  }

  .asset-allocation h2,
  .preview-panel h2 {
    font-size: 16px;
  }

  .sub-title {
    font-size: 12px;
  }

  .asset-category {
    padding: 14px;
  }

  .category-header span {
    font-size: 13px;
  }

  .slider-container {
    gap: 12px;
  }

  .chart-container {
    padding: 16px;
  }

  .pie-chart {
    width: 260px;
    height: 180px;
  }

  .allocation-suggestion {
    padding: 16px;
  }

  .allocation-suggestion h3 {
    font-size: 16px;
  }

  .allocation-suggestion li {
    font-size: 12px;
  }

  .footer {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .reset-btn,
  .confirm-btn {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }
}
</style>

<style lang="less">
/* ===== 权重数字键盘弹窗样式（非 scoped，因为弹窗在 body 层级需要全局样式） ===== */
.numpad-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2000;
}

.numpad-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 320px;
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);
  z-index: 9999;
}

.numpad-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.numpad-popup-close {
  width: 28px;
  height: 28px;
  border: none;
  background: #f1f5f9;
  border-radius: 50%;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
}

.numpad-popup-close:hover {
  background: #e2e8f0;
}

.numpad-popup-display {
  text-align: right;
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 10px;
  margin-bottom: 16px;
  font-feature-settings: 'tnum';
}

.numpad-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 16px;
}

.numpad-btn {
  padding: 12px 0;
  font-size: 18px;
  font-weight: 600;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #1e293b;
  cursor: pointer;
  transition: all 0.15s;
  text-align: center;
}

.numpad-btn:hover {
  background: #e2e8f0;
}

.numpad-btn:active {
  background: #cbd5e1;
}

.numpad-btn-zero {
  grid-column: 1 / 2;
}

.numpad-btn-del {
  color: #ef4444;
}

.numpad-confirm {
  width: 100%;
  padding: 10px;
  font-size: 15px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: #fff;
  cursor: pointer;
  transition: all 0.2s;
}

.numpad-confirm:hover {
  opacity: 0.9;
}
</style>